import axios from 'axios';
import { toast } from 'react-toastify';
import { ACTIVE_FOOTBALL_LIST_ERROR, ACTIVE_FOOTBALL_LIST_SUCCESS, ACTIVE_FOOTBALL_MATCH_POOL_LIST_SUCCESS, FOOTBALL_MATCH_STATUS_CHANGED_ERROR, FOOTBALL_MATCH_STATUS_CHANGED_SUCCESS, IS_LOADING, POOL_ADD_ERROR, POOL_ADD_SUCCESS, POOL_LIST_ERROR, POOL_LIST_SUCCESS, POOL_PRIZE_BREAK_ERROR, POOL_PRIZE_BREAK_SUCCESS, POOL_STATUS_CHANGED_ERROR, POOL_STATUS_CHANGED_SUCCESS, UPCOMING_FOOTBALL_LIST_ERROR, UPCOMING_FOOTBALL_LIST_SUCCESS, ACTIVE_FOOTBALL_MATCH_POOL_LIST_ERROR, PUBLISH_FOOTBALL_MATCH_POOL_SUCCESS, PUBLISH_FOOTBALL_MATCH_POOL_ERROR } from './Type';
import { baseUrlPostGres } from '../constant';
import { apiHeader } from './ApiHeader';
import 'react-toastify/dist/ReactToastify.css';
import HandleError from '../HandleError';
import { apiVersion } from 'src/utils/apiVersion';
toast.configure();

export const GetUpcomingFootballMatchListAction = (page, limit) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/football/list?page=${page}&limit=${limit}`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: UPCOMING_FOOTBALL_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: UPCOMING_FOOTBALL_LIST_ERROR,
                payload: errors
            })
        })
}


export const GetFootballPoolListAction = (page, size, id) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    let sendData = {
        contest_id: id
    }
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/list?page=${page}&limit=${size}`, sendData, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: POOL_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: POOL_LIST_ERROR,
                payload: errors
            })
        })
}

export const GetFootballActiveMatchAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/football/active_pool_list`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: ACTIVE_FOOTBALL_MATCH_POOL_LIST_SUCCESS,
                payload: response.data
            })
            toast.success(response.data.message, { theme: "colored" })

        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: ACTIVE_FOOTBALL_MATCH_POOL_LIST_ERROR,
                payload: errors
            })
            toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
        })
}

export const GetActiveFootballMatchListAction = (page, size) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .get(`${baseUrlPostGres()}/admin/${apiVersion.v1}/football/active_list?page=${page}&limit=${size}`, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: ACTIVE_FOOTBALL_LIST_SUCCESS,
                payload: response
            })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: ACTIVE_FOOTBALL_LIST_ERROR,
                payload: errors
            })
        })
}

export const GetActiveFootballMatchAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/football/active_pool_list`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: ACTIVE_FOOTBALL_MATCH_POOL_LIST_SUCCESS,
                payload: response.data
            })
            toast.success(response.data.message, { theme: "colored" })

        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: ACTIVE_FOOTBALL_MATCH_POOL_LIST_ERROR,
                payload: errors
            })
            toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
        })
}

export const PublichActiveFootballMatchStatusAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/football/publish`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: PUBLISH_FOOTBALL_MATCH_POOL_SUCCESS,
                payload: response.data
            })
            toast.success(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: PUBLISH_FOOTBALL_MATCH_POOL_ERROR,
                payload: errors
            })
            toast.error(errors.response.data.message, { theme: "colored" })
        })
}

export const FootballMatchChangeStatusAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/football/active-inactive`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: FOOTBALL_MATCH_STATUS_CHANGED_SUCCESS,
                payload: response.data
            })
            toast.success(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: FOOTBALL_MATCH_STATUS_CHANGED_ERROR,
                payload: errors
            })
            toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
        })
}
//FootballCancelMatchAction
export const FootballCancelMatchAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/football/cancel-match`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: FOOTBALL_MATCH_STATUS_CHANGED_SUCCESS,
                payload: response.data
            })
            toast.success(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: FOOTBALL_MATCH_STATUS_CHANGED_ERROR,
                payload: errors
            })
            toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
        })
}
export const AddPoolAction = (data, formValues) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/create`, data, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: POOL_ADD_SUCCESS,
                payload: response
            })
            toast.success(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: POOL_ADD_ERROR,
                payload: errors
            })
        })

    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/pool_range`, formValues, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: POOL_PRIZE_BREAK_SUCCESS,
                payload: response
            })
            toast.success(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: POOL_PRIZE_BREAK_ERROR,
                payload: errors
            })
        })
}


export const PoolChangeStatusAction = (body) => async (dispatch) => {
    dispatch({ type: IS_LOADING })
    await axios
        .post(`${baseUrlPostGres()}/admin/${apiVersion.v1}/poolmaster/active_inactive_pool`, body, {
            headers: apiHeader()
        })
        .then(response => {
            dispatch({
                type: POOL_STATUS_CHANGED_SUCCESS,
                payload: response.data
            })
            toast.success(response.data.message, { theme: "colored" })
        })
        .catch(errors => {
            HandleError(errors.response.data)
            dispatch({
                type: POOL_STATUS_CHANGED_ERROR,
                payload: errors
            })
            toast.error(errors.error.errorMessage.id.message, { theme: "colored" })
        })
}